<app-student-nav></app-student-nav>
<app-messages-thread-page></app-messages-thread-page>
